import InsuranceProvidersSelect from '@components/common/insurance-providers-select';
import { Form, TextField } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import ExpertiseSelect from '../../../../../components/common/expertise-select';
import ImageUploader from '../image-uploader';

const gte = (e: any) => e;

const BaseForm: React.FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Form.Field name="image" getValueFromEvent={gte}>
        <ImageUploader />
      </Form.Field>
      <Form.Section label="Základné údaje">
        <Form.Field name="name" label={formatMessage({ id: 'departments_modal_name' })} required>
          <TextField />
        </Form.Field>
        <Form.Field
          required
          name="specialization"
          label={formatMessage({ id: 'departments_modal_specialization' })}
          getValueFromEvent={gte}
        >
          <ExpertiseSelect />
        </Form.Field>
        <Form.Field
          name="medicalInsurances"
          label={formatMessage({ id: 'departments_modal_medicalInsurances' })}
          getValueFromEvent={gte}
        >
          <InsuranceProvidersSelect />
        </Form.Field>
      </Form.Section>
      <Form.Section label="Kontaktné údaje">
        <Form.Field
          name="contactEmail"
          label={formatMessage({ id: 'departments_modal_email' })}
          required
        >
          <TextField />
        </Form.Field>
        <Form.Field
          name="contactPhone"
          label={formatMessage({ id: 'departments_modal_phoneNumber' })}
          required
        >
          <TextField />
        </Form.Field>
      </Form.Section>
    </>
  );
};

export default BaseForm;
